import { useEffect, useState } from 'react';
import { cachedGet } from 'Utils/cachedGet';
import { countFoundFlows } from 'Shared/flows/folders/folderUtils';

export const useFoundCounts = (source, search, folders) => {
    const [flows, setFlows] = useState(null);

    useEffect(() => {
        if (!search) {
            setFlows(null);
            return;
        }
        cachedGet(`${source}${source.includes('?') ? '&' : '?'}search=${encodeURIComponent(search)}&folder_id=any`)
            .then((res) => setFlows(Array.isArray(res.data.flows) ? res.data.flows : Object.values(res.data.flows || {})))
            .catch(() => setFlows(null));
    }, [source, search]);

    return flows ? countFoundFlows(folders, flows) : null;
};
